var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 37,
    viewBox: "0 0 95 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3653 2.19928C2.3653 5.38891 1.87305 8.484 1.87305 11.6751C1.87305 16.6977 1.9623 21.9642 3.47285 26.798C4.29152 29.4178 6.34963 31.9209 8.65513 33.334C10.7183 34.5985 13.3989 34.6877 15.7654 34.6877C17.9147 34.6877 20.2228 34.3536 21.563 32.4178C22.7162 30.7521 23.8137 29.172 24.5712 27.2492C25.131 25.828 25.2955 24.4497 25.7471 23.0104C27.8311 16.3677 28.4544 9.61601 28.4544 2.69153",
    stroke: "#B00487",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7949 31.4744C73.6343 32.256 74.7152 32.6684 75.7585 33.1542C76.432 33.4677 77.1072 33.8169 77.8201 34.054C78.4259 34.2555 79.1362 34.648 79.76 34.7206C81.3068 34.9006 82.8516 34.9096 84.3771 34.5939C85.8653 34.286 87.3894 33.7128 88.7723 33.1275C91.4656 31.9875 92.8955 28.9747 92.8955 26.3086C92.8955 24.7544 92.6551 23.2073 91.4782 21.996C90.4498 20.9377 89.4955 20.225 88.0708 19.6564C86.2626 18.9348 84.4142 18.4217 82.5159 17.9167C81.4415 17.6308 80.4734 17.2751 79.4522 16.8902C78.657 16.5905 78.0507 16.1143 77.3047 15.757C75.9146 15.0913 74.538 13.9318 73.9546 12.5576C73.1442 10.6489 72.8486 8.25894 74.0906 6.45191C76.513 2.92737 81.5577 2.19928 85.7085 2.19928C87.548 2.19928 90.2439 2.76215 92.4954 4.45076",
    stroke: "#FF630B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/US.0c3cf3141adf69fda630f483f0536df3.svg";
export { ForwardRef as ReactComponent };